export type PointsEarnTextOptions = {
  firstMention?: boolean;
  lowercase?: boolean;
};

const getPointsEarnText = (
  pointsPerDollar: number,
  opts?: PointsEarnTextOptions,
) => {
  const pointsLabel = opts?.firstMention ? 'PTS' : 'points';
  const earnCased = opts?.lowercase ? 'earn' : 'Earn';

  return `${earnCased} ${pointsPerDollar} ${pointsLabel} per A$1 spent`;
};

export default getPointsEarnText;
